const Hero = () => {
  const hero = document.getElementsByClassName("hero");
  const heroVideo = document.querySelector(".hero__video");
  const videoBreakpoint = 768;

  function toggleVideo() {
    window.toggleVideoSource(heroVideo, videoBreakpoint);
  }

  function destroy() {
    window.removeEventListener("resize", toggleVideo);
  }

  destroy();

  if (hero && heroVideo) {
    // Remove previous event listeners
    window.removeEventListener("resize", toggleVideo);

    toggleVideo();
    window.addEventListener("resize", toggleVideo);
  }
};

export default Hero;
